import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
    isLoggedOut: false,
  },

  reducers: {
    loginSuccess: (state, action) => {
      state.currentUser = action.payload;
      state.isLoggedOut = false; // reset flag
    },

    logout: (state) => {
      // return initialState;
      // state = initialState;
      state.currentUser = null;
      state.isLoggedOut = true; // mark as logged out
    },
  },
});

export const { loginSuccess, logout } = userSlice.actions;

export default userSlice.reducer;
